import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Box, Button, FormField, Text } from '@campaignhub/suit-theme'
import { useSetState, useThunkDispatch } from '@campaignhub/react-hooks'
import PageContext from '@contexts/pageContext'

import custom from '@styles/custom.module.scss'
import { patchServiceJobCritical } from '@redux/modules/serviceJob'

const defaultState = {
  isReasonValid: true,
  isCritical: false,
  reason: '',
}

const ServiceJobCritical = () => {
  const { serviceJob } = useContext(PageContext)
  const { updating } = useSelector(reduxState => reduxState.serviceJobs)

  const dispatch = useThunkDispatch()
  const [state, setState] = useSetState(defaultState)
  const { isReasonValid, isCritical, reason } = state

  useEffect(() => {
    if (serviceJob) {
      setState({ isCritical: serviceJob?.campaign?.critical, reason: serviceJob?.campaign?.criticalNote || '' })
    }
  }, [serviceJob])

  const handleSave = () => {
    const trimmedReason = reason.trim()
    const isValid = trimmedReason.length > 0 || !isCritical
    setState({ isReasonValid: isValid })

    if (isValid) {
      const serviceJobParam = {
        id: serviceJob.id,
        serviceJob,
        payload: {
          isCritical,
          criticalNote: trimmedReason,
        }
      }
      dispatch(patchServiceJobCritical(serviceJobParam, {}))
    }
  }

  return (
    <>

      <Box flexDirection="row" paddingBottom="small" alignItems="center">
        <input
          type="checkbox"
          className={custom.checkbox}
          onChange={e => setState({ isCritical: e.target.checked, reason: '' })}
          checked={isCritical}
        />
        <Box flexDirection="column" paddingLeft="small">
          <Text fontSize="small">Mark as Critical</Text>
          <Text fontSize="xsmall" color="bodyFontLightColor" paddingTop="small">
            Updating this checkbox clears the reason field
          </Text>
        </Box>
      </Box>
      <FormField errorMessage={!isReasonValid ? 'Required' : ''}>
        <textarea
          type="text"
          onChange={ev => setState({ reason: ev.target.value })}
          placeholder="Reason required to mark as critical"
          style={{ height: 65, resize: 'vertical', paddingBottom: 'small' }}
          value={reason}
        />
      </FormField>
      <Button buttonStyle="secondaryUtility" size="medium" onClick={handleSave} marginTop="small" loading={updating}>
        Save Changes
      </Button>
    </>
  )
}

ServiceJobCritical.propTypes = {}

export default ServiceJobCritical
